import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-financeiro-modal-pagamento',
  templateUrl: './financeiro-modal-pagamento.component.html',
  styleUrls: ['./financeiro-modal-pagamento.component.css'],
  standalone: false
})
export class FinanceiroModalPagamentoComponent {
  @Input() pagamento: any;
  @Output() fechar = new EventEmitter<void>();
  @Output() confirmar = new EventEmitter<void>();

  fecharModal() {
    this.fechar.emit();
  }

  confirmarPagamento() {
    this.confirmar.emit();
  }
}
